import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CompanyConfigs } from '../models/CompanyOnboardingModels';

interface UserDetailsStateData {
  companyConfigs: CompanyConfigs;
}

const initialState: UserDetailsStateData = {
  companyConfigs: {
    enableTransfer: true,
    enablePush: true,
    enablePull: true,
    enablePullTransfer: true,
    enablePushLaptop: true,
    scheduleEndDateWindowLimit: 'P6M',
    scheduleStartDateWindowLimit: 'P13M',
    deviceAssetTagNumberLimit: 50,
    deviceFreeTextLimit: 50,
  },
};

export const UserDetailsSlice = createSlice({
  name: 'userDetails',
  initialState,
  reducers: {
    reset: () => initialState,
    setCompanyConfigs: (state, action: PayloadAction<CompanyConfigs>) => {
      state.companyConfigs = action.payload;
    },
  },
});

export const { reset, setCompanyConfigs } = UserDetailsSlice.actions;

export default UserDetailsSlice.reducer;
